import { useTranslation } from 'react-i18next'

import { Box } from '@mui/material'

import { Testimonial } from '@pages/LandingPage/components/Testimonial'

import { containerSx, contentSx, testimonialContainerSx } from './styles'

const Testimonial1Section = () => {
  const { t } = useTranslation()

  return (
    <Box
      data-testid="tech-vendors-features-testimonial-1-section"
      sx={containerSx}
    >
      <Box sx={contentSx}>
        <Testimonial
          variant="dark"
          testimonialText={t(
            'The Launchpad’s marketplace is a unique way to connect with prospective customers, and 100% in line with the way they want to engage, so the engagements are better and more meaningful. And at this price point, it’s a no brainer to participate because the investment is so low compared to other demand generation and marketing activities.'
          )}
          personName="Kelly M."
          personPosition={t('Alliance Manager')}
          containerSx={testimonialContainerSx}
        />
      </Box>
    </Box>
  )
}

export { Testimonial1Section }
